import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { ar, en } from '../utils/translations';

const ConnectionStatus = ({ language = 'ar' }) => {
  const t = language === 'ar' ? ar : en;
  const [isConnected, setIsConnected] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, 10000); // Check every 10 seconds
    return () => clearInterval(interval);
  }, []);

  const checkConnection = async () => {
    try {
      const response = await api.get('/health', { validateStatus: () => true }); // Don't throw on 404
      setIsConnected(response.status === 200);
      setChecking(false);
    } catch (error) {
      console.error('Connection check failed:', error);
      setIsConnected(false);
      setChecking(false);
    }
  };

  if (checking) return null;

  if (!isConnected) {
    return (
      <div style={{
        background: '#ffe8cc',
        border: '1px solid #ff9500',
        borderRadius: '8px',
        padding: '15px',
        margin: '20px 0',
        color: '#000000'
      }}>
        <strong>⚠️ {t.serverConnectionError}</strong>
        <p style={{ marginTop: '10px', marginBottom: '10px' }}>
          {t.cannotConnect}
        </p>
        <p style={{ marginBottom: '0', fontSize: '0.9rem', opacity: '0.8' }}>
          <strong>{t.toStartServer}</strong><br />
          {t.runCommand}
        </p>
      </div>
    );
  }

  return null;
};

export default ConnectionStatus;

